<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <div class="row">
                <div class="col col-md-12">
                  <pr-input-radio
                    formControlName="fcpiDeliveryMode"
                    direction="column"
                    [isDefault]="false"
                    columns="2"
                    [options]="fcpiDeliveryModeOptions"
                    label="Je souhaite que les parts souscrites soient livrées"
                  >
                  </pr-input-radio>
                </div>
              </div>
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
